import { useState, useCallback } from "react";
import api from "../../services/api";

function useAxios() {
  const [response, setResponse] = useState(null)

  const fetchVeterinariansAddresses = useCallback(() => {
    api.get('/veterinarios').then(res => {
      const veterinarians = res.data.resultado
      setResponse(veterinarians.map(veterinarian => veterinarian.endereco));
    })
  }, []);

  const fetchUnitsAddresses = useCallback(() => {
    api.get('/unidades').then(res => {
      const units = res.data.resultado
      setResponse(units.map(unit => unit.endereco));
    })
  }, []);

  const fetchVeterinarians = useCallback(() => {
    api.get('/veterinarios')
    .then(res => setResponse(res.data.resultado))
  }, [])

  const fetchUnits = useCallback(() => {
    api.get('/unidades')
    .then(res => setResponse(res.data.resultado))
  }, []);

  const fetchVeterinarian = useCallback((id) => {
    api.get(`/veterinarios?id=${id}`)
    .then(res => setResponse(res.data.resultado))
    .catch(() => {})
  }, [])

  const fetchUnit = useCallback((id) => {
    api
    .get(`/unidades?id=${id}`)
    .then(res => setResponse(res.data.resultado))
    .catch(() => {})
  }, [])

  return {
    fetchVeterinariansAddresses,
    fetchUnitsAddresses,
    fetchVeterinarian,
    fetchVeterinarians,
    fetchUnit,
    fetchUnits,
    response, 
    setResponse
  }
}
export default useAxios;